import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { AdminService, GisticUser } from './admin.service';

@Injectable()
export class ResolverGisticUsersService implements Resolve<GisticUser[]> {

	constructor(
		private adminService: AdminService
	) { }
	
	async resolve() {
		let users: GisticUser[] = [];
		try {
			users = await this.adminService.getGisticUsers();
		} catch (err) {
			console.log(err);
		}
		return users;
	}
}



// WEBPACK FOOTER //
// ./src/app/common-services/resolver-gistic-users.service.ts